/**
 * Refactored Mobile Nav JS for Window Film World
 * Extracted and simplified from Empire's StaticHeader bundle
 */
(function($) {
  'use strict';

  var MobileNav = {
    init: function() {
      this.$header = $('.wfw-header');
      this.$toggleOpen = $('[data-menu-toggle]');
      this.$mobileNav = $('[data-mobile-nav]');
      this.$navPanel = $('[data-mobile-nav-panel]');
      this.$navOverlay = $('[data-mobile-nav-overlay]');
      this.$toggleClose = $('[data-mobile-nav-close]');
      this.isOpen = false;

      if (!this.$toggleOpen.length || !this.$mobileNav.length) return;

      this._bindEvents();
    },

    _bindEvents: function() {
      var _this = this;

      this.$toggleOpen.on('click', function(e) {
        e.preventDefault();
        _this._open();
      });

      this.$toggleClose.on('click', function(e) {
        e.preventDefault();
        _this._close();
      });

      this.$navOverlay.on('click', function(e) {
        e.preventDefault();
        _this._close();
      });

      this.$navOverlay.on('touchmove', function(e) {
        e.preventDefault();
      });

      $(window).on('keydown', function(e) {
        if (e.key === 'Escape' && _this.isOpen) {
          _this._close();
        }
      });

      // Submenu handling (Accordion)
      this.$mobileNav.on('click', '[data-navmenu-trigger]', function(e) {
        e.preventDefault();
        _this._toggleSubmenu($(this));
      });

      // Also handle clicking the link if it's a parent
      this.$mobileNav.on('click', '.navmenu-link-parent', function(e) {
        var $item = $(this).closest('[data-navmenu-parent]');
        if ($item.length && !$(this).hasClass('navmenu-link-parent-active')) {
          e.preventDefault();
          _this._toggleSubmenu($item.find('[data-navmenu-trigger]').first());
        }
      });
    },

    _open: function() {
      if (this.isOpen) return;
      
      this.isOpen = true;
      this.$mobileNav.attr('data-open', 'true');
      
      // Force a reflow to ensure the initial state is applied before animation
      this.$navPanel[0].offsetHeight;
      this.$navOverlay[0].offsetHeight;
      
      // Animate panel and overlay
      this.$navPanel.attr('data-animation-state', 'open');
      this.$navOverlay.attr('data-animation-state', 'open');

      $('html').addClass('scroll-locked'); // Match Empire's scroll lock class
      
      this.$mobileNav.focus();
      // In a real empire theme, there's trapFocus, but we'll stick to basics or use theme-a11y if available
      if (window.theme && window.theme.a11y && window.theme.a11y.trapFocus) {
        window.theme.a11y.trapFocus(this.$mobileNav[0]);
      }
    },

    _close: function() {
      if (!this.isOpen) return;

      var _this = this;
      this.isOpen = false;

      // Animate panel and overlay to closed
      this.$navPanel.attr('data-animation-state', 'closed');
      this.$navOverlay.attr('data-animation-state', 'closed');

      // Add temporary animation class for specific closing transition if needed
      this.$navPanel.attr('data-animation', 'open=>closed');
      this.$navOverlay.attr('data-animation', 'open=>closed');

      // Wait for animation to finish before hiding the whole nav container
      setTimeout(function() {
        if (!_this.isOpen) {
          _this.$mobileNav.attr('data-open', 'false');
          _this.$navPanel.removeAttr('data-animation');
          _this.$navOverlay.removeAttr('data-animation');
        }
      }, 400); // 400ms is slightly more than the longest transition (350ms)

      $('html').removeClass('scroll-locked');

      if (window.theme && window.theme.a11y && window.theme.a11y.removeTrapFocus) {
        window.theme.a11y.removeTrapFocus(this.$mobileNav[0]);
      }
      this.$toggleOpen.focus();
    },

    _toggleSubmenu: function($trigger) {
      var $parent = $trigger.closest('[data-navmenu-parent]');
      var $submenu = $parent.children('[data-navmenu-submenu]');
      var $link = $parent.children('.navmenu-link');
      var isExpanded = $trigger.attr('aria-expanded') === 'true';

      if (isExpanded) {
        $trigger.attr('aria-expanded', 'false');
        $link.attr('aria-expanded', 'false').removeClass('navmenu-link-parent-active');
        $submenu.slideUp(300);
      } else {
        // Optional: Close other submenus at the same level
        // $parent.siblings().find('[aria-expanded="true"]').trigger('click');

        $trigger.attr('aria-expanded', 'true');
        $link.attr('aria-expanded', 'true').addClass('navmenu-link-parent-active');
        $submenu.slideDown(300);
      }
    }
  };

  $(document).ready(function() {
    MobileNav.init();
  });

})(jQuery);
